import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface FamilyStepsInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",
    editId?: string,
    editTitle?: string,
    editAlias?: string,
    editActive?: boolean,
    deleteModalVisible: boolean,
    deleteId?: string,
}

function getInitialState(): FamilyStepsInterface {
    return {
        formVisible: false,
        formVariant: "new",
        deleteModalVisible: false,
    }
}

export const FamilyStepsSlice = createSlice({
    name: "FamilyStepsSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => {
            return getInitialState()
        },
        updateFields: (state, action: PayloadAction<Partial<FamilyStepsInterface>>) => {
            Object.assign(state, action.payload)
        }
    },
});

export const {
    reset,
    updateFields
} = FamilyStepsSlice.actions;

export const FamilyStepsSelectors = {
    formVisible: (state: RootState) => state.familySteps.formVisible,
    formVariant: (state: RootState) => state.familySteps.formVariant,
    editId: (state: RootState) => state.familySteps.editId,
    editTitle: (state: RootState) => state.familySteps.editTitle,
    editAlias: (state: RootState) => state.familySteps.editAlias,
    editActive: (state: RootState) => state.familySteps.editActive,
    deleteModalVisible: (state: RootState) => state.familySteps.deleteModalVisible,
    deleteId: (state: RootState) => state.familySteps.deleteId,
}

export const FamilyStepsReducer = FamilyStepsSlice.reducer;
